export default "__VITE_ASSET__0e471e46__"